// Lib
import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { withFormik, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import moment from 'moment'

// Images

// Include in project
import Color from 'abstracts/export.module.scss'
import styles from './index.module.scss'
import { useDashboard } from 'hooks'
import type { RootState } from 'states/store'
import { ByZoneStar } from 'utils/generated'
import { SelectSingle, DatePickers, Notification } from 'component'

const BarGraphProvinceStar: React.FC = () => {
  const { values } = useFormikContext<any>()

  const getZoneListReducer = useSelector((state: RootState) => state.zone)
  const { getByZoneStar, dataByZoneStar, errMsg } = useDashboard()
  useEffect(() => {
    if (!values.timeDuration[0]) return
    if (!values.timeDuration[1]) return

    getByZoneStar({
      variables: {
        startDate: values.timeDuration[0].toISOString(),
        endDate: values.timeDuration[1].toISOString(),
        zoneID: values.zoneID,
      },
    })
  }, [values.zoneID, values.timeDuration, getZoneListReducer.zoneListOption])

  const optionsBarTotalStar: any = {
    plugins: {
      title: {
        display: true,
        text: 'Star by Province',
      },
      datalabels: {
        display: true,
        color: 'black',
      },
      legend: {
        display: true,
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: 'Month',
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Star',
        },
      },
    },
  }

  const labels = dataByZoneStar?.items?.map((data: ByZoneStar) => data.provinceName)

  const dataBarTotalStar = {
    labels,
    datasets: [
      {
        label: 'Basic star',
        data: dataByZoneStar?.items?.map((data: ByZoneStar) => data.basicStar),
        backgroundColor: `${Color.warningBorder}`,
      },
      {
        label: 'Campaign star',
        data: dataByZoneStar?.items?.map((data: ByZoneStar) => data.bonusStar),
        backgroundColor: `${Color.grey200}`,
      },
    ],
  }

  const [isOpen, setIsOpen] = useState<boolean>(false)
  useEffect(() => {
    if (errMsg) return setIsOpen(true)
  }, [errMsg])
  return (
    <>
      <div className={styles.filter}>
        <SelectSingle
          name="zoneID"
          label={'Zone'}
          option={getZoneListReducer.zoneListOption}
          disabled={false}
          require
        />
        <DatePickers name="timeDuration" label={'Time Duration'} require />
      </div>
      <Bar options={optionsBarTotalStar} data={dataBarTotalStar} />
      <Notification
        title="Error From Server"
        description={errMsg}
        isOpen={isOpen}
        onClose={() => setIsOpen(!isOpen)}
        type="danger"
      />
    </>
  )
}

const EnhancedBarGraphProvinceStar = withFormik({
  mapPropsToValues: () => ({
    zoneID: 1,
    timeDuration: [moment().subtract(1, 'month').toDate(), moment().toDate()],
  }),
  handleSubmit: () => {
    console.log('Skip')
  },
})(BarGraphProvinceStar)

export default EnhancedBarGraphProvinceStar
